export const EVENT_NAME = 'LoginWebEvent' as const;
export const SCHEMA_NAME = 'login_web_event' as const;

export const ACTIONS = {
  UNSET_ACTION: 'UNSET_ACTION',
  MARKETING_CAPTURE_VIEW: 'MARKETING_CAPTURE_VIEW',
  MARKETING_CAPTURE_OPT_IN_CLICK: 'MARKETING_CAPTURE_OPT_IN_CLICK',
  MARKETING_CAPTURE_OPT_OUT_CLICK: 'MARKETING_CAPTURE_OPT_OUT_CLICK',
  LOGIN_INTRO_VIEW: 'LOGIN_INTRO_VIEW',
  LOGIN_INTRO_PROVIDER_CLICK: 'LOGIN_INTRO_PROVIDER_CLICK',
  LOGIN_DISMISS: 'LOGIN_DISMISS',
  ONE_TIME_PASSWORD_VIEW: 'ONE_TIME_PASSWORD_VIEW',
  ONE_TIME_PASSWORD_VERIFY: 'ONE_TIME_PASSWORD_VERIFY',
  ONE_TIME_PASSWORD_RESEND: 'ONE_TIME_PASSWORD_RESEND',
  LOG_IN_SUCCESS_VIEW: 'LOG_IN_SUCCESS_VIEW',
  REGULATORY_CONSENT_VIEW: 'REGULATORY_CONSENT_VIEW',
  REGULATORY_CONSENT_ACCEPT: 'REGULATORY_CONSENT_ACCEPT',
  GOOGLE_ONE_TAP_PROMPT_REQUEST: 'GOOGLE_ONE_TAP_PROMPT_REQUEST',
  GOOGLE_ONE_TAP_PROMPT_CLICK: 'GOOGLE_ONE_TAP_PROMPT_CLICK',
  GOOGLE_ONE_TAP_RETRY_VIEW: 'GOOGLE_ONE_TAP_RETRY_VIEW',
  GOOGLE_ONE_TAP_RETRY_CLICK: 'GOOGLE_ONE_TAP_RETRY_CLICK',
  GOOGLE_ONE_TAP_FALLBACK_VIEW: 'GOOGLE_ONE_TAP_FALLBACK_VIEW',
  GOOGLE_ONE_TAP_FALLBACK_CLICK: 'GOOGLE_ONE_TAP_FALLBACK_CLICK',
} as const;

export const COMPONENTS = {
  UNSET_COMPONENT: 'UNSET_COMPONENT',
  LOGIN_FORM_GC: 'LOGIN_FORM_GC',
  GOOGLE_ONE_TAP_GC: 'GOOGLE_ONE_TAP_GC',
  MARKETING_CONSENT_GC: 'MARKETING_CONSENT_GC',
} as const;

export const PROVIDERS = {
  UNSET_PROVIDER: 'UNSET_PROVIDER',
  EMAIL: 'EMAIL',
  APPLE: 'APPLE',
  FACEBOOK: 'FACEBOOK',
  GOOGLE: 'GOOGLE',
} as const;

export const STEP_NAME = {
  UNSET_STEP_NAME: 'UNSET_STEP_NAME',
  INTRO: 'INTRO',
  OTP: 'OTP',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  MARKETING_CONSENT: 'MARKETING_CONSENT',
  REGULATORY_CONSENT: 'REGULATORY_CONSENT',
  CANCELLED: 'CANCELLED',
  ERROR: 'ERROR',
  MARKETING_CAPTURE: 'MARKETING_CAPTURE',
  PROMPT: 'PROMPT',
  RETRY: 'RETRY',
  FALLBACK: 'FALLBACK',
} as const;

/**
 * @public
 * A list of features, used to identity the trigger of an interaction with login web components.
 */
export const SOURCES = {
  UNSET_SOURCE: 'UNSET_SOURCE',
  S2L_ITINERARY: 'S2L_ITINERARY',
  S2L_HEADER_ICON: 'S2L_HEADER_ICON',
  PRICE_ALERTS: 'PRICE_ALERTS',
  GOOGLE_ONE_TAP: 'GOOGLE_ONE_TAP',
  HEADER: 'HEADER',
  AUTO_PROMPT: 'AUTO_PROMPT',
  TRIP: 'TRIP',
  OTHER: 'OTHER',
} as const;
